module.exports = __webpack_public_path__ + "static/media/StoreLocatorLandingScreen.3cffe7be.png";